/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-CPC Import API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AsyncHandlingResponseRestDto } from '../models';
import { HandleCsvRequestRestDto } from '../models';
import { HandleXlsxRequestRestDto } from '../models';
import { PrepareCsvHandlingRequestRestDto } from '../models';
import { PrepareImportHandlingResponseRestDto } from '../models';
import { PrepareXlsxHandlingRequestRestDto } from '../models';
/**
 * ImportAPIApi - axios parameter creator
 * @export
 */
export const ImportAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.CPC.IMPORT.02 Handle an uploaded csv.
         * @param {HandleCsvRequestRestDto} body 
         * @param {string} import_type_code The type of csv that is beïng handled.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleCsv: async (body: HandleCsvRequestRestDto, import_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling handleCsv.');
            }
            // verify required parameter 'import_type_code' is not null or undefined
            if (import_type_code === null || import_type_code === undefined) {
                throw new RequiredError('import_type_code','Required parameter import_type_code was null or undefined when calling handleCsv.');
            }
            const localVarPath = `/import/v1/import_type/{import_type_code}/handle_csv`
                .replace(`{${"import_type_code"}}`, encodeURIComponent(String(import_type_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CPC.IMPORT.04 Handle an uploaded xlsx.
         * @param {HandleXlsxRequestRestDto} body 
         * @param {string} import_type_code The type of csv that is beïng handled.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleXlsx: async (body: HandleXlsxRequestRestDto, import_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling handleXlsx.');
            }
            // verify required parameter 'import_type_code' is not null or undefined
            if (import_type_code === null || import_type_code === undefined) {
                throw new RequiredError('import_type_code','Required parameter import_type_code was null or undefined when calling handleXlsx.');
            }
            const localVarPath = `/import/v1/import_type/{import_type_code}/handle_xlsx`
                .replace(`{${"import_type_code"}}`, encodeURIComponent(String(import_type_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CPC.IMPORT.01 Prepare the handling of an uploaded csv.
         * @param {PrepareCsvHandlingRequestRestDto} body 
         * @param {string} import_type_code The type of document that is being handled.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareCsvHandling: async (body: PrepareCsvHandlingRequestRestDto, import_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling prepareCsvHandling.');
            }
            // verify required parameter 'import_type_code' is not null or undefined
            if (import_type_code === null || import_type_code === undefined) {
                throw new RequiredError('import_type_code','Required parameter import_type_code was null or undefined when calling prepareCsvHandling.');
            }
            const localVarPath = `/import/v1/import_type/{import_type_code}/prepare_csv_handling`
                .replace(`{${"import_type_code"}}`, encodeURIComponent(String(import_type_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CPC.IMPORT.03 Prepare the handling of an uploaded xlsx.
         * @param {PrepareXlsxHandlingRequestRestDto} body 
         * @param {string} import_type_code The type of document that is being handled.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareXlsxHandling: async (body: PrepareXlsxHandlingRequestRestDto, import_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling prepareXlsxHandling.');
            }
            // verify required parameter 'import_type_code' is not null or undefined
            if (import_type_code === null || import_type_code === undefined) {
                throw new RequiredError('import_type_code','Required parameter import_type_code was null or undefined when calling prepareXlsxHandling.');
            }
            const localVarPath = `/import/v1/import_type/{import_type_code}/prepare_xlsx_handling`
                .replace(`{${"import_type_code"}}`, encodeURIComponent(String(import_type_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportAPIApi - functional programming interface
 * @export
 */
export const ImportAPIApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.CPC.IMPORT.02 Handle an uploaded csv.
         * @param {HandleCsvRequestRestDto} body 
         * @param {string} import_type_code The type of csv that is beïng handled.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleCsv(_axios: AxiosInstance, body: HandleCsvRequestRestDto, import_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AsyncHandlingResponseRestDto>> {
            const localVarAxiosArgs = await ImportAPIApiAxiosParamCreator(configuration).handleCsv(body, import_type_code, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CPC.IMPORT.04 Handle an uploaded xlsx.
         * @param {HandleXlsxRequestRestDto} body 
         * @param {string} import_type_code The type of csv that is beïng handled.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleXlsx(_axios: AxiosInstance, body: HandleXlsxRequestRestDto, import_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AsyncHandlingResponseRestDto>> {
            const localVarAxiosArgs = await ImportAPIApiAxiosParamCreator(configuration).handleXlsx(body, import_type_code, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CPC.IMPORT.01 Prepare the handling of an uploaded csv.
         * @param {PrepareCsvHandlingRequestRestDto} body 
         * @param {string} import_type_code The type of document that is being handled.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prepareCsvHandling(_axios: AxiosInstance, body: PrepareCsvHandlingRequestRestDto, import_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrepareImportHandlingResponseRestDto>> {
            const localVarAxiosArgs = await ImportAPIApiAxiosParamCreator(configuration).prepareCsvHandling(body, import_type_code, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CPC.IMPORT.03 Prepare the handling of an uploaded xlsx.
         * @param {PrepareXlsxHandlingRequestRestDto} body 
         * @param {string} import_type_code The type of document that is being handled.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prepareXlsxHandling(_axios: AxiosInstance, body: PrepareXlsxHandlingRequestRestDto, import_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrepareImportHandlingResponseRestDto>> {
            const localVarAxiosArgs = await ImportAPIApiAxiosParamCreator(configuration).prepareXlsxHandling(body, import_type_code, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ImportAPIApi - object-oriented interface
 * @export
 * @class ImportAPIApi
 * @extends {BaseAPI}
 */
export class ImportAPIApi extends BaseAPI {
    /**
     * 
     * @summary REST.API.CPC.IMPORT.02 Handle an uploaded csv.
     * @param {HandleCsvRequestRestDto} body 
     * @param {string} import_type_code The type of csv that is beïng handled.
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportAPIApi
     */
     public handleCsv(body: HandleCsvRequestRestDto, import_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return ImportAPIApiFp(this.configuration).handleCsv(this.axios, body, import_type_code, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CPC.IMPORT.04 Handle an uploaded xlsx.
     * @param {HandleXlsxRequestRestDto} body 
     * @param {string} import_type_code The type of csv that is beïng handled.
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportAPIApi
     */
     public handleXlsx(body: HandleXlsxRequestRestDto, import_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return ImportAPIApiFp(this.configuration).handleXlsx(this.axios, body, import_type_code, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CPC.IMPORT.01 Prepare the handling of an uploaded csv.
     * @param {PrepareCsvHandlingRequestRestDto} body 
     * @param {string} import_type_code The type of document that is being handled.
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportAPIApi
     */
     public prepareCsvHandling(body: PrepareCsvHandlingRequestRestDto, import_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return ImportAPIApiFp(this.configuration).prepareCsvHandling(this.axios, body, import_type_code, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CPC.IMPORT.03 Prepare the handling of an uploaded xlsx.
     * @param {PrepareXlsxHandlingRequestRestDto} body 
     * @param {string} import_type_code The type of document that is being handled.
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportAPIApi
     */
     public prepareXlsxHandling(body: PrepareXlsxHandlingRequestRestDto, import_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return ImportAPIApiFp(this.configuration).prepareXlsxHandling(this.axios, body, import_type_code, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

}
